import { render, staticRenderFns } from "./addApplyRoomDiscount.vue?vue&type=template&id=12ec9fbd&scoped=true"
import script from "./addApplyRoomDiscount.vue?vue&type=script&lang=js"
export * from "./addApplyRoomDiscount.vue?vue&type=script&lang=js"
import style0 from "./addApplyRoomDiscount.vue?vue&type=style&index=0&id=12ec9fbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ec9fbd",
  null
  
)

export default component.exports